import { render } from "./EditArea.vue?vue&type=template&id=1d900622&scoped=true"
import script from "./EditArea.vue?vue&type=script&lang=js"
export * from "./EditArea.vue?vue&type=script&lang=js"

import "./EditArea.vue?vue&type=style&index=0&id=1d900622&scoped=true&lang=css"

import exportComponent from "/home/hkohashi/webinar-master-php83/frontend-system/node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__scopeId',"data-v-1d900622"]])

export default __exports__